import { IMPERSONATION_RADE_PLATFORM } from 'domain/value-objects/impersonation-rade-platform';

import { PersonImpersonationMainContent } from '../../components/person-impersonation-main-content';

export const OrganizacaoPersonImpersonation = () => {
  return (
    <PersonImpersonationMainContent
      targetRadePlatform={IMPERSONATION_RADE_PLATFORM.ORGANIZACAO}
    />
  );
};
